module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account--wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-push-4 col-md-4"
  }, [_c('div', {
    staticClass: "card ui-card form--account"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_copy_program')) + ": " + _vm._s(_vm.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_pp_name')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.name),
      expression: "model.name"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_pp_name'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "name", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_pp_name_en')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.enName),
      expression: "model.enName"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_pp_name_en'),
      "name": "uplata"
    },
    domProps: {
      "value": (_vm.model.enName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "enName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_pp_from_date")))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.selectedUsers.length === 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.showChoseUser()
      }
    }
  }, [_vm._v("+"), _c('i', {
    staticClass: "ti-user"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_pp_add_user_to_program")) + "\n                                ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedUsers.length > 0) ? _c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.selectedUsers), function(sUser) {
    return _c('div', {
      staticClass: "form-group text-center"
    }, [_c('b', [_vm._v(_vm._s(sUser.name) + " " + _vm._s(sUser.surname) + " (" + _vm._s(sUser.username) + ")")]), _vm._v(" " + _vm._s(_vm.locale.t("label_pp_user_to_be_added")) + " "), _c('i', {
      staticClass: "ti-trash",
      staticStyle: {
        "color": "#FF0000",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.removeSelectedUser(sUser)
        }
      }
    })])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.partnerCompanies.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_company_partners')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPartnerCompany),
      expression: "selectedPartnerCompany"
    }],
    staticClass: "form-control input",
    attrs: {
      "name": "uloga"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPartnerCompany = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                                      " + _vm._s(_vm.locale.t('label_without_company_partners')) + "\n                                    ")]), _vm._v(" "), _vm._l((_vm.partnerCompanies), function(item) {
    return _c('option', {
      domProps: {
        "value": item.name
      }
    }, [_vm._v("\n                                      " + _vm._s(item.name) + "\n                                    ")])
  })], 2)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.copyPersonalProgram
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_save")) + "\n                                        ")])])])])], 1)])])])]), _vm._v(" "), _c('choose-user-modal', {
    attrs: {
      "show": _vm.chooseUser
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "ti-user"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d8cecca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Personal/CopyPersonalProgram.vue
// module id = 734
// module chunks = 0